import {
  Tag as ChakraTag,
  TagProps as ChakraTagProps,
  TagLabel as ChakraTagLabel,
  TagRightIcon as ChakraTagRightIcon
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

import IconButton from 'atoms/Button/IconButton';
import { forwardRef } from 'system';

const propTypes = {
  children: PropTypes.string.isRequired,
  size: PropTypes.string,
  isRemovable: PropTypes.bool,
  onClickRemove: PropTypes.func,
  ariaLabelRemove: PropTypes.string
};

const defaultProps = {
  size: 'md',
  isRemovable: false,
  ariaLabelRemove: 'Remove'
};

export type TagProps = ChakraTagProps & {
  isRemovable?: boolean;
  onClickRemove?: React.MouseEventHandler<HTMLButtonElement>;
  ariaLabelRemove?: string;
};

const Tag = forwardRef(
  (props: TagProps, ref): React.ReactElement => {
    const RightIconButton = ChakraTagRightIcon as typeof IconButton;
    const { isRemovable, onClickRemove, ariaLabelRemove, ...tagProps } = props;

    return (
      <ChakraTag ref={ref} {...tagProps}>
        <ChakraTagLabel>{props.children}</ChakraTagLabel>
        {isRemovable && (
          <RightIconButton
            aria-label={ariaLabelRemove}
            as={IconButton}
            height="24px"
            margin="0 -6px 0 0"
            onClick={onClickRemove}
            size="xs"
            type="XClose"
            variant="ghost"
          />
        )}
      </ChakraTag>
    );
  }
);

Tag.displayName = DisplayNames.Tag;
Tag.propTypes = propTypes;
Tag.defaultProps = defaultProps;

export default Tag;
